<template>
    <div
        v-if="opt"
        class="option-btn-group-v2 option-btn-prominent-item option-btn-tall g-col-1 pb-5"
    >
        <v-btn
            class="rounded selected"
            variant="outlined"
            :block="block"
        >
            <div
                class="text-center d-flex flex-column align-center justify-center"
            >
                <div class="d-flex flex-row align-center justify-center">
                    <ColorSwatch
                        v-if="opt.value.colors?.length"
                        class="mr-2"
                        :color="opt.value.colors"
                    ></ColorSwatch>
                    <strong>{{ opt.value.name }}</strong>
                </div>
                <div
                    v-if="opt.value.description"
                    class="sub-text"
                >
                    {{ opt.value.description }}
                </div>
            </div>
        </v-btn>
    </div>
</template>

<script lang="ts" setup>
    import ColorSwatch from '~/components/color/ColorSwatch/ColorSwatch.vue';
    import type { ProductAttrsGroupOption } from '~/types';

    const props = defineProps<{
        option: ProductAttrsGroupOption;
        block?: boolean;
    }>();

    const opt = computed(() => props.option.groupValues?.[0]);
</script>

<style lang="scss"></style>
